import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, Tab, Tabs } from "@mui/material";

import { TabPanel, TabProps } from "../../../helpers/TabPanel";

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout"
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { BoxInformacionIrregular } from "../../../components/BoxInformacionIrregular";
import { BoxInformacionAmparo } from "../../../components/BoxInformacionAmparo";
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion";
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";
import { BoxInformacionExhortoRecibido } from "../../../components/BoxInformacionExhortoRecibido";
import { InfoField } from "../../../components/InfoField";

import { Destinatarios } from "./Destinatarios";

import { ActualizarEstatusOficio, DetalleOficio } from "../../../connections/tribunal/OficioConnection";

import { defaultDependencia, DependenciaProps } from "../../../interfaces/catalogos/DependenciaInterface";
import { defaultOficio, DestinatarioProps, OficioProps } from "../../../interfaces/tribunal/OficioInterface";

export const VisualizarOficioPage = () => {

    const dispatch = useDispatch();

    const { Id } = useParams();

    const [value, setValue] = useState( 0 );

    const [oficio, setOficio] = useState<OficioProps>( defaultOficio );

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [destinatarios, setDestinatarios] = useState<DestinatarioProps[]>( [] );
    const [dependencia, setDependencia] = useState<DependenciaProps>( defaultDependencia );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );

    const handleChange = ( _: React.SyntheticEvent, newValue: number ) => setValue( newValue )

    const handleFinalizar = async () => {

        setLoadingFinalizar( true );

        await ActualizarEstatusOficio({ idOficio: Id ?? '', idEstatus: 3, observaciones: '', }).then(resp => {

            setTimeout(() => {

                const { success, message, } = resp;

                if ( success ) {

                    setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                    setProcesoTerminado( true );
                    setLoadingFinalizar( false );

                }
                else {

                    dispatch(openSnackbar({ message: message, variant: 'error' }));
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        setLoading( true );

        async function Obtener() {

            await DetalleOficio( Id ?? '' ).then(resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setOficio( resp );

                        setDestinatarios( resp.destinatarios );
                        setDependencia( resp.dependencia ?? defaultDependencia );

                        if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ resp.usuarioAsignado }`);
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 45 ) {
                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 45 ) {
                            setLoading( false );
                        }
                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if ( Id ) {
            Obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Oficio' }, { text: 'Visualizar oficio' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                ?
                    procesoNoEncontrado
                    ?
                        <BoxProcesoNoEncontrado />
                    :
                        procesoCancelado
                        ?
                            <BoxProcesoCancelado />
                        :
                            <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ oficio.idEstatus === 3 } />
                    :
                        loading
                        ?
                            <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                                <CircularProgressIndicator />
                            </Box>
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange }>

                                        <Tab label="Oficio" {...TabProps(0)} />
                                        <Tab label="Destinatario(s)" {...TabProps(1)} />

                                        <Tab
                                            label="Información del amparo"
                                            sx={{ display: oficio.idAmparo !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(3)}
                                        />

                                        <Tab
                                            label="Información del expediente"
                                            sx={{ display: oficio.idExpediente !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(4)}
                                        />

                                        <Tab
                                            label="Información del exhorto"
                                            sx={{ display: oficio.idExhortoRecibido !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(5)}
                                        />

                                        <Tab
                                            label="Información del irregular"
                                            sx={{ display: oficio.idIrregular !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(6)}
                                        />
                                    </Tabs>

                                </Box>

                                <TabPanel value={ value } index={ 0 }>

                                    <Box p={ 4 } component={ Paper }>

                                        <BoxHeaderInformacion numeroSeguimiento={ "GOF-" + oficio.idOficio } fecha={ oficio.fecha ?? new Date() } juez={ oficio.juez } numeroOficio={ oficio.numeroOficio } />

                                        <Grid container spacing={ 3 } mt={ 2 }>

                                            {
                                                oficio.plantilla
                                                &&
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="Plantilla"
                                                            value={ oficio.plantilla }
                                                        />

                                                    </Grid>
                                            }

                                            {
                                                oficio.idAmparo !== 0
                                                &&
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="Tipo de oficio de amparo"
                                                            value={ oficio.subTipoAcuerdo }
                                                        />

                                                    </Grid>

                                            }

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="¿El oficio será firmado por el juez?"
                                                    value={ oficio.firmaJuez ? "Si" : "No" }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <iframe
                                                    title='iframe-documento'
                                                    style={{ width: '100%', height: 800, borderRadius: 8 }}
                                                    src={ oficio.documento }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                                <Grid container spacing={ 3 }>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'left' }}> </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'center' }}>
                                                        <Button
                                                            fullWidth
                                                            color='primary'
                                                            variant="contained"
                                                            onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                        >
                                                            Finalizar
                                                        </Button>
                                                    </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right' }}> </Grid>

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 1 }>

                                    <Destinatarios setDependencia={ setDependencia } setDestinatarios={ setDestinatarios } dependencia={ dependencia } destinatarios={ destinatarios } edit={ false } cumplimientoEjecutoria={ oficio.idAmparo !== 0 && oficio.idSubTipoAcuerdo === 17 } />

                                </TabPanel>

                                <TabPanel value={ value } index={ 2 }>

                                    <BoxInformacionAmparo amparo={ oficio.amparo } />

                                </TabPanel>

                                <TabPanel value={ value } index={ 3 }>

                                    <BoxInformacionExpediente
                                        expediente={ oficio.expediente }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 4 }>

                                    <BoxInformacionExhortoRecibido
                                        exhortoRecibido={ oficio.exhortoRecibido }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 5 }>

                                    <BoxInformacionIrregular irregular={ oficio.irregular } />

                                </TabPanel>

                                <Dialog
                                    fullWidth
                                    maxWidth='xs'
                                    open={ openDialogConfirmacionFinalizar }
                                    onClose={ () => { } }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea finalizar la visualizacion del oficio?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>
                                        <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar(false) }> Cancelar </Button>
                                        <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>
                                    </DialogActions>
                                </Dialog>
                            </>
            }

        </Layout>
    )
}
